import { ArticleParagraph1 } from '@cian/ui-kit';

import { type FC } from 'react';

import { LayoutBlock } from '../LayoutBlock';

interface IAboutProps {
  contentText: string;
  sectionTabTitle: string;
  title: string;
  onView: () => void;
}

export const About: FC<IAboutProps> = ({ contentText, sectionTabTitle, title, onView }) => {
  return (
    <LayoutBlock id="about" sectionTabTitle={sectionTabTitle} title={title} onView={onView}>
      <ArticleParagraph1 whiteSpace="pre-wrap">{contentText}</ArticleParagraph1>
    </LayoutBlock>
  );
};
